// extracted by mini-css-extract-plugin
export default {"item":"item_MVH6N","description":"description_lzzj2","price":"price_mm7Ta","characteristics":"characteristics_XaObi","address":"address_g6vT0"};